class ExternalReportController {
    constructor(ReportServiceApi, UtpSimServiceApi, GroupTesterSimServiceApi, toastr, $interval, $window, ngProgressFactory) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.state = {
                report: null,
                statusText: '',
                showLoadingSpinner: true
            };
            this.reportParametersFields = [];
            this.reportParametersModel = [];
            this.traceProgress = this.ngProgressFactory.createInstance();
            this.report = this.resolve.report;
            this.user = this.resolve.user.data || this.resolve.user;
            this.selectedSim = this.resolve.simulator;
            this.state.report = this.report;
            this.getReportParams();
        };
        this.getReportParams = () => {
            this.traceProgress.start();
            this.state.showLoadingSpinner = true;
            this.UtpSimServiceApi.isSimulatorActive(this.selectedSim.id, this.user.Id).then((simResponse) => {
                let isSimulatorReady = simResponse.data;
                if (isSimulatorReady) {
                    this.traceProgress.complete();
                    this.state.showLoadingSpinner = false;
                }
                else {
                    this.traceProgress.complete();
                    this.state.showLoadingSpinner = false;
                    this.toastr.info('Simulator not available to run report');
                    this.close();
                    return;
                }
            });
            if (this.selectedSim.type === 'GroupTemplate' && this.user.IsGroupTester) {
                let simlockRequest = {
                    TesterId: this.user.Id,
                    SimId: this.selectedSim.id
                };
                this.GroupTesterSimServiceApi.isSimulatorLocked(simlockRequest).then((response) => {
                    let lockResponse = response.data;
                    if (lockResponse.IsLocked && _.isNil(lockResponse.LockingError)) {
                        this.toastr.info('Reports not accessible. ' + lockResponse.LockingSSOUserDetails['IdPEmail'] + ' is currently testing with the simulator');
                        this.close();
                        return;
                    }
                });
            }
            this.ReportServiceApi.getReportParameters(this.selectedSim.id, this.user.Id, this.report.Id).then((getParamsResponse) => {
                this.traceProgress.complete();
                this.state.showLoadingSpinner = false;
                let reportParamsResponse = getParamsResponse.data;
                if (reportParamsResponse.Status) {
                    if (reportParamsResponse.ReportParameters.length === 0) {
                        this.generateReport(reportParamsResponse.ReportParameters);
                    }
                    else {
                        this.buildFormlyFieldDefinition(reportParamsResponse.ReportParameters);
                    }
                }
                else {
                    this.toastr.error('Error retrieving report parameters, please contact system administrator');
                    this.close();
                }
            });
        };
        this.isInvalidString = (str) => {
            let invalidChars = '{};<>$~';
            for (let i = 0; i < invalidChars.length; i++) {
                if (_.indexOf(str, invalidChars[i]) > -1) {
                    return true;
                }
            }
            return false;
        };
        this.generateReport = (reportParamsModel) => {
            this.traceProgress.start();
            this.state.showLoadingSpinner = true;
            let req = {
                SimId: this.selectedSim.id,
                UserId: this.user.Id,
                ReportId: this.report.Id,
                ReportParameters: {}
            };
            let flag = false;
            // API expects only strings so have to do a little conversion
            for (let key in reportParamsModel) {
                let paramValue = reportParamsModel[key].toString();
                flag = this.isInvalidString(paramValue);
                if (flag) {
                    this.toastr.error('Parameter ' + key + '  contains illegal characters');
                    this.traceProgress.complete();
                    this.state.showLoadingSpinner = false;
                    return;
                }
                req.ReportParameters[key] = paramValue;
            }
            this.ReportServiceApi.generateReport(req).then((response) => {
                this.traceProgress.complete();
                this.state.showLoadingSpinner = false;
                let reportGenerating = response.data;
                if (response.status === 200 && reportGenerating) {
                    this.getReport(req.SimId, req.UserId);
                }
                else {
                    this.toastr.error('Error generating the report, please contact system administrator');
                }
            });
        };
        this.getReport = (simId, userId) => {
            this.traceProgress.start();
            this.state.showLoadingSpinner = true;
            this.getReportPromise = this.$interval(() => {
                // Check every 3 seconds to see if the report is ready
                this.ReportServiceApi.getReportReady(simId, userId).then((response) => {
                    let reportReadyResp = response.data;
                    if (reportReadyResp.ReportReady) {
                        // Redirect to download if it is
                        this.state.showLoadingSpinner = false;
                        this.traceProgress.complete();
                        let url = ['api/Report/GetReport?simId=', this.selectedSim.id, '&userId=', this.user.Id].join('');
                        this.$window.location.href = url;
                        this.$interval.cancel(this.getReportPromise);
                        this.close();
                    }
                    else if (reportReadyResp.ReportFailed) {
                        this.traceProgress.complete();
                        this.toastr.error('Error generating the report: ' + reportReadyResp.FailureReason);
                        this.$interval.cancel(this.getReportPromise);
                        this.close();
                    }
                });
            }, 3000);
        };
        this.buildFormlyFieldDefinition = (reportParameters) => {
            // Clear out existing model definition
            this.reportParametersFields = [];
            let result = _.groupBy(reportParameters, 'Type');
            for (let type in result) {
                let row;
                if (type.toUpperCase() === 'BOOLEAN') {
                    // If it's a bool put them all in the same row so they don't take so much space
                    row = {
                        className: 'row',
                        fieldGroup: []
                    };
                    for (let param of result[type]) {
                        row.fieldGroup.push(this.buildFormlyField(param));
                    }
                    this.reportParametersFields.push(row);
                }
                else {
                    // Anything else (e.g string) just give it it's own row as it will be an input box, textarea, datetime picker e.t.c
                    for (let param of result[type]) {
                        row = {
                            className: 'row',
                            fieldGroup: []
                        };
                        row.fieldGroup.push(this.buildFormlyField(param));
                        this.reportParametersFields.push(row);
                    }
                }
            }
        };
        this.buildFormlyField = (reportParam) => {
            let defaultValue = '';
            let htmlType = 'input';
            let title = '';
            let pattern = '';
            let fieldClassName = 'col-xs-12';
            switch (reportParam.Type.toUpperCase()) {
                case 'BOOLEAN':
                    htmlType = 'checkbox';
                    defaultValue = false;
                    fieldClassName = 'col-xs-6';
                    break;
            }
            switch (reportParam.DisplayName.toUpperCase()) {
                case 'COMMENTS':
                    htmlType = 'textarea';
                    break;
                case 'REPORT NAME':
                    title = '0-100 characters required';
                    pattern = '^(.{0,100})$';
                    break;
            }
            let fieldGroup = {
                key: reportParam.Name,
                type: htmlType,
                className: fieldClassName,
                defaultValue: defaultValue,
                templateOptions: {
                    label: reportParam.DisplayName,
                    placeholder: '',
                    required: false,
                    pattern: pattern
                },
                elementAttributes: {
                    title: title
                }
            };
            return fieldGroup;
        };
        this.ReportServiceApi = ReportServiceApi;
        this.UtpSimServiceApi = UtpSimServiceApi;
        this.GroupTesterSimServiceApi = GroupTesterSimServiceApi;
        this.toastr = toastr;
        this.$interval = $interval;
        this.$window = $window;
        this.ngProgressFactory = ngProgressFactory;
    }
}
angular.module('app').component('externalReport', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&',
        report: '<'
    },
    templateUrl: 'scripts/app/partials/Reports/external-report.tpl.html',
    controllerAs: 'vm',
    controller: ExternalReportController
});
